export const RERENDER_NON_HYDRATED_ARTICLE_COMPONENTS_BUS_NAME =
  'RERENDER_NON_HYDRATED_ARTICLE_COMPONENTS_BUS_NAME'
